// Centralized API configuration
// Use same-origin (empty string) to leverage the proxy in package.json
// This works for both local development and Replit's proxy configuration
export const API_URL = '';

export const getApiUrl = (endpoint) => {
  return `${API_URL}${endpoint}`;
};
